
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/update-profile",
      function () {
        return require("private-next-pages/account/update-profile/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/update-profile"])
      });
    }
  